export default __webpack_public_path__ + "static/media/twitter.9789642f.svg";